import React from "react";
import { Link } from "react-router-dom";
import { UserCheck, ArrowRight } from "lucide-react";

const TemporaryToHire = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">
          Temporary-to-Hire
        </h1>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex items-center mb-4">
            <UserCheck className="w-12 h-12 text-red-500 mr-4" />
            <p className="text-xl text-gray-700">
              Trial employees before making a permanent commitment.
            </p>
          </div>
          <p className="text-gray-600 mb-4">
            Our Temporary-to-Hire service allows you to evaluate potential
            employees in real work situations before offering them a permanent
            position. This approach reduces hiring risks and ensures a great fit
            for both the employer and the employee.
          </p>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            How It Works
          </h2>
          <ol className="list-decimal list-inside mb-6 text-gray-700">
            <li className="mb-2">
              We identify candidates that match your requirements
            </li>
            <li className="mb-2">
              Candidates work for you on a temporary basis
            </li>
            <li className="mb-2">
              You evaluate their performance and cultural fit
            </li>
            <li className="mb-2">
              If satisfied, you can offer a permanent position
            </li>
            <li>We assist with the transition to permanent employment</li>
          </ol>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center text-lg font-semibold"
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TemporaryToHire;
